import DashboardEmptyStateCard from '../../DashboardEmptyStateCard';
import PropertyIcon from '@/public/images/dashboard/property.svg';
import Trans from '@/components/shared/Trans';
import translations from '../../Dashboard.trans.json';

function PendingReservationsEmptyState() {
  return (
    <DashboardEmptyStateCard
      icon={PropertyIcon}
      title={Trans(
        translations,
        'HereYouWillSeePropertyReservationsThatAreAboutToExpire'
      )}
      description={Trans(
        translations,
        'YouCanRegisterTheReservationByIndicatingItsDuration'
      )}
    />
  );
}

export default PendingReservationsEmptyState;
